import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12a6 6 0 1 0 12 0a6 6 0 1 0 -12 0","key":"svg-0"}],["path",{"d":"M13 13l5 5","key":"svg-1"}]]

/**
 * IconCurrencyQuetzal
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktcXVldHphbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNiAxMmE2IDYgMCAxIDAgMTIgMGE2IDYgMCAxIDAgLTEyIDAiIC8+CiAgPHBhdGggZD0iTTEzIDEzbDUgNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-quetzal
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyQuetzal = createReactComponent('outline', 'currency-quetzal', 'CurrencyQuetzal', __iconNode);

export default IconCurrencyQuetzal;